import { FLIP, LANDED, SEEN, TOSS } from './constants';

/**
 * A move's coins to toss on the board before the move shows: `waitForTap` when they're the player's own, so they
 * flip them; the opponent's toss by themselves.
 */
export const toss = (version, flips, waitForTap) => ({
  type: TOSS,
  payload: { version, flips, waitForTap },
});

/** The player tapped the coin. */
export const flip = () => ({ type: FLIP });

/** Every coin has landed: the move can show. */
export const landed = () => ({ type: LANDED });

/** Flips already shown (the game as it was when it loaded), so they don't toss again. */
export const seen = (version) => ({ type: SEEN, payload: { version } });
